import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api, { fmtINR, fmtNum } from '@/lib/api';
import { Button } from '@/components/ui/button';
import { Loading, SectionTitle } from '@/components/Shared';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';

export default function Catalog() {
  const nav = useNavigate();
  const [products, setProducts] = useState(null);
  const [cat, setCat] = useState('All');
  useEffect(() => { api.get('/products').then((r) => setProducts(r.data)); }, []);
  if (!products) return <Loading />;
  const cats = ['All', 'Diesel', 'Lubricants', 'Other'];
  const list = cat === 'All' ? products : products.filter((p) => p.category === cat);
  return (
    <div className="space-y-4">
      <SectionTitle>Product Catalogue</SectionTitle>
      <Tabs value={cat} onValueChange={setCat}>
        <TabsList>{cats.map((c) => <TabsTrigger key={c} value={c} data-testid={`catalog-cat-${c.toLowerCase()}`}>{c}</TabsTrigger>)}</TabsList>
      </Tabs>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {list.map((p) => (
          <div key={p.id} className="rounded-xl border border-border bg-card overflow-hidden hover:shadow-md transition-shadow" data-testid={`product-card-${p.sku}`}>
            <div className="h-32 bg-muted" style={{ backgroundImage: `url(${p.image})`, backgroundSize: 'cover', backgroundPosition: 'center' }} />
            <div className="p-4">
              <div className="flex items-start justify-between"><div><p className="font-semibold">{p.name}</p><p className="text-xs text-muted-foreground">{p.brand} · {p.sku}</p></div><span className="text-xs rounded-full bg-muted px-2 py-0.5">{p.category}</span></div>
              <p className="text-sm text-muted-foreground mt-2 line-clamp-2">{p.description}</p>
              <div className="mt-3 flex items-center justify-between">
                <div><span className="font-display text-lg font-semibold">{fmtINR(p.price)}</span><span className="text-xs text-muted-foreground">/{p.unit}</span></div>
                <Button size="sm" onClick={() => nav(`/app/order/${p.id}`)} data-testid={`order-product-${p.sku}`}>Order</Button>
              </div>
              <p className="text-[11px] text-muted-foreground mt-2">Min order: {fmtNum(p.min_order_qty)} {p.unit} · {p.gst > 0 ? `GST ${p.gst}%` : 'No GST (fuel)'}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
